<template>
  <main role="main" style="text-align: center;">
    <div class="px-4">
      <div class="max-w-container mx-auto mt-6 rounded shadow bg-white">
        <p v-if="error == '' && !loading && newsItems(filter).length == 0" ref="emptyResults">
          No news found.
        </p>
        <div
          v-if="error.length > 0"
          ref="errorMessage"
          class="bg-red-100 border border-red-400 text-red-600 px-4 py-3 rounded relative"
          role="alert"
        >
          <p class="font-bold">
            A failure occurred when loading the news. Please retry.
          </p>
        </div>

        <div v-if="loading && error.length == 0" ref="loading">
          Loading...
          <div class="lds-ring mx-auto">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div v-if="!loading && newsItems(filter).length > 0" class="pb-2 mb-2">
          <NewsFilter :isModalShown="isModalShown" :selectedFilter="filter" />
            <div v-for="newsItem in newsItems(filter)" :key="newsItem.id">
              <NewsCard
                v-if="newsItem.type == 'newsReleases'"
                :title="newsItem.title"
                :pubDate="newsItem.pubDate"
                :subtitle="newsItem.plainDesc"
                :type="newsItem.type"
                :link="newsItem.url"
                v-on:toggleModal="showModal(newsItem.title, newsItem.subtitle, newsItem.url)"
                :isModalShown="isModalShown"
              />
            </div>
        </div>
      </div>
    </div>
    <CardModal ref="Modal" :showing="isModalShown" v-on:close="hideModal()">
      <a class="text-xl font-bold text-gray-900" :href="modalLink" target="_blank">{{ modalTitle }}</a>
      <p class="mb-6 text-left text-base" v-html="modalSubTitle"></p>
    </CardModal>
  </main>
</template>

<script>
import NewsCard from "@/components/NewsCard.vue"
import NewsFilter from "@/components/NewsFilter.vue"
import { createNamespacedHelpers, mapGetters } from "vuex"

import CardModal from "@/components/CardModal.vue"

export default {
  components: { NewsFilter, NewsCard, CardModal },
  data() {
    return {
      filter: null,
      error: "",
      loading: false,
      modalTitle: null,
      modalLink: null,
      modalSubTitle: null,
      isModalShown: false,
    }
  },
  computed: {
    ...mapGetters("news", ["newsItems"]),
  },
  methods: {
    /**
     * Updates the data model to display modal with the specified parameters
     */
    showModal: function(title, subTitle, link) {
      this.modalTitle = title
      this.modalLink = link
      this.modalSubTitle = subTitle
      this.isModalShown = true
    },
    /**
     * Updates teh data model to not display the modal
     */
    hideModal: function() {
      this.isModalShown = false
    },
  },
  // ------------------
  // VueJS Lifecycle Hooks
  // ------------------
  async mounted() {
    // --- fetch the data
    this.error = ""
    this.loading = true

    try {
      await this.$store.dispatch("news/loadNews")
    } catch (error) {
      this.error = error
    }
    this.loading = false
    // --
  },
  beforeRouteUpdate(to, from, next) {
    // --- update routing when this component is loaded
    this.filter = to.params.tab
    next()
  },
  updated() {
    // --- update routing when this component is NOT loaded
    let urlParam = undefined

    if (this.$route !== undefined) {
      // for unit tests
      urlParam = this.$route.params.tab
    }

    if (urlParam !== undefined && urlParam !== null) {
      this.filter = urlParam
    }
    // --
  },
}
</script>
